module.exports = __webpack_public_path__ + "img/icon-livecasino-white.ce69e98e.svg";